import { useRef, type ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface DashboardActionsProps {
  onFile: (file: File) => void;
  onManual: () => void;
  onExport: () => void;
  onExportAnnual: () => void;
  onManageObras: () => void;
  busy: boolean;
  year: string;
}

export function DashboardActions({
  onFile,
  onManual,
  onExport,
  onExportAnnual,
  onManageObras,
  busy,
  year,
}: DashboardActionsProps) {
  const { t } = useTranslation();
  const photoRef = useRef<HTMLInputElement>(null);
  const pdfRef = useRef<HTMLInputElement>(null);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) onFile(file);
  }

  const secondary =
    'flex flex-1 min-w-[9.5rem] items-center justify-center gap-2 rounded-xl border border-conduril-border ' +
    'bg-white px-4 py-2.5 text-sm font-semibold text-conduril-ink shadow-btn transition min-h-[46px] ' +
    'hover:bg-conduril-surface hover:border-conduril-soft active:scale-[0.99] disabled:opacity-60';

  return (
    <div className="flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:items-stretch">
      <button
        type="button"
        disabled={busy}
        onClick={() => photoRef.current?.click()}
        className="flex flex-[1.6] min-w-[12rem] items-center justify-center gap-2.5 rounded-xl bg-gradient-to-b from-conduril-light to-conduril px-5 py-2.5 text-base font-semibold text-white shadow-btn transition min-h-[46px] hover:shadow-btnhover hover:brightness-[1.06] active:scale-[0.99] disabled:opacity-60"
      >
        <span className="text-xl">📷</span>
        {t('dashboard.photo')}
      </button>
      <input ref={photoRef} type="file" accept="image/*" capture="environment" onChange={handleChange} className="hidden" />

      <button type="button" disabled={busy} onClick={() => pdfRef.current?.click()} className={secondary}>
        📄 {t('dashboard.importPdf')}
      </button>
      <input ref={pdfRef} type="file" accept="application/pdf,image/*" onChange={handleChange} className="hidden" />

      <button type="button" onClick={onManual} className={secondary}>
        ＋ {t('dashboard.manual')}
      </button>
      <button type="button" onClick={onExport} className={secondary}>
        ⬇ {t('dashboard.exportPdf')}
      </button>
      <button type="button" onClick={onExportAnnual} className={secondary}>
        📅 {t('dashboard.exportAnnual', { year })}
      </button>
      <button type="button" onClick={onManageObras} className={secondary}>
        🗂 {t('dashboard.manageObras')}
      </button>
    </div>
  );
}
